@if (showEmailForm) {
  <lib-forgot-password-email
    [labels]="'lib.forgotPasswordEmail' | translate"
    [confirmationLabels]="'lib.forgotPasswordConfirmation' | translate"
    [bank]="theme"
    [emailParam]="emailParam"
    (close)="closeDialog()"
    (emailSubmitted)="onEmailSubmitted($event)"
  ></lib-forgot-password-email>
}

@if (showEmailSentPopup) {
  <div
    class="fixed inset-0 z-[100] w-full flex justify-center items-center bg-black/50"
    >
    <lib-modal
      [bank]="theme"
      [labels]="'lib.modal' | translate"
      [title]="'globalUi.forgotPassword.linkSentTitle' | translate"
      [text1]="'globalUi.emailSent.sentTo' | translate"
      [text2]="userEmail"
      [text3]="'globalUi.forgotPassword.toReset' | translate"
      [text4]="'globalUi.emailSent.notReceived' | translate"
      [buttonLabel]="'globalUi.emailSent.resend' | translate"
      (buttonClicked)="ResendConfirmationEmail()"
      (closeModal)="showEmailSentPopup = false"
    ></lib-modal>
  </div>
}

@if (showSnackbar) {
  <div class="relative z-[100]">
    <lib-snackbar
      [labels]="'lib.snackbar' | translate"
      [theme]="snackbarTheme"
      [position]="'bottom'"
      [bank]="theme"
      [title]="snackbarText"
      [showIconLeft]="true"
      [showIconRight]="false"
    ></lib-snackbar>
  </div>
}
